import { createStyles, makeStyles } from "@material-ui/core";
import { baseColors, RelodeTheme, Tile as CoreTile } from "@relode/core";
import * as React from "react";

/* eslint-disable quotes */
export const useDashboardTileStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            title: {
                color: baseColors.gray,
            },
            content: {
                color: baseColors.navy,
            },
        }),
    { name: "DashboardTile" }
);

export const DashboardTile = React.memo(
    (props: {
        id: string;
        children: React.ReactNode;
        title?: string;

        subTitle?: React.ReactNode;
        isBusy?: boolean;
        useSubTitle?: boolean;
        usePaper?: boolean;
        onClick?: () => void;
        small?: boolean;
        showAsLink?: boolean;
    }) => {
        const classes = useDashboardTileStyles({});

        return (
            <CoreTile
                {...props}
                useSubTitle={props.useSubTitle}
                small={props.small}
                usePaper={props.usePaper}
                classes={{
                    title: classes.title,
                    content: classes.content,
                }}
            />
        );
    }
);
